import {
  useSelectFilterLogic,
  type UseSelectFilterLogicProps,
} from "~/features/selectionAssistant/gearbox/components/CharacteristicsFilter/components/useSelectFilterLogic";
import { type CSSProperties } from "react";
import { Select } from "~/common/components/Select/Select";
import { SimpleSelectItem } from "~/common/components/Select/SimpleSelect";

type Props = Omit<UseSelectFilterLogicProps, "multiselect"> & {
  className?: string;
  style?: CSSProperties;
};
export const SingleSelectFilter = ({ className, style, ...rest }: Props) => {
  const { name, items, trackingCode } = useSelectFilterLogic({ ...rest, multiselect: false });
  const value = rest.value[0] ?? "";

  return (
    <Select
      variant={"outlined"}
      style={style}
      className={className}
      label={name}
      value={value}
      onChange={(e) => {
        const val = e.target.value;
        // TODO - Check after m-ui update
        rest.onChange((val ? [val] : []) as string[]);
      }}
      MenuProps={{
        "tracking-aux-section-marker": trackingCode,
      }}
    >
      {items.map((item) => (
        <SimpleSelectItem
          onClick={() => {
            // Deselect
            if (item.code === value) {
              rest.onChange([]);
            }
          }}
          key={item.code}
          value={item.code}
          disabled={item.disabled}
          tracking-aux-option-marker={item.trackingCode}
        >
          {item.name}
        </SimpleSelectItem>
      ))}
    </Select>
  );
};
